import React, { useState } from "react";
import CustomTab from "../../../components/common/CustomTab";
import CustomDialog from "../../../components/common/CustomDialog";
import { ArrowLeft, AlertTriangle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ProviderForm from "./ProviderForm";
import TemplatesTab from "./TemplatesTab";
import InvoiceSchedulerTab from "./InvoiceSchedulerTab";
import DownloadExcel from "../Invoice/DownloadExcel"
// const LeadAssignmentTab = () => {
//   return <div>Lead Assignment Content</div>;
// };





const Invoice = () => {
  const navigate = useNavigate();
  const [isAddProviderOpen, setIsAddProviderOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState({ open: false, type: null, data: null });
  const [isLoading, setIsLoading] = useState(false);
  const [conflictModal, setConflictModal] = useState({ open: false, current: null, next: null });

  // Mock data for providers
  const [providers, setProviders] = useState([
    {
      id: 1,
      type: 'whatsapp',
      providerName: "Brevo",
      apiKey: "abc123xyz789",
      senderName: "Starfor Support",
      senderEmail: "Support@gmail.com",
      isActive: true
    },
    {
      id: 2, 
      type: 'sms',
      providerName: "Twilio",
      apiKey: "def456uvw012",
      senderName: "Starfor Bot",
      senderEmail: "Starfor@mail.com",
      isActive: false
    },
    {
      id: 3,
      type: 'email',
      providerName: "Mailgun",
      apiKey: "ghi789rst345", 
      senderName: "Starfor Notifications",
      senderEmail: "Support@gmail.com",
      isActive: false
    },
    {
        id: 4,
        type: 'sms',
        providerName: "Mailgun",
        apiKey: "ghi789rst345", 
        senderName: "Starfor Notifications",
        senderEmail: "Support@gmail.com",
        isActive: false
      },
      {
        id: 6,
        type: 'email',
        providerName: "Mailgun",
        apiKey: "ghi789rst345", 
        senderName: "Starfor Notifications",
        senderEmail: "Support@gmail.com",
        isActive: false
      }
  ]);

  const handleStatusChange = (id, newStatus) => {
    if (newStatus) {
      const selectedProvider = providers.find((p) => p.id === id);
      // Find active provider of the same type
      const activeProvider = providers.find((p) => p.isActive && p.type === selectedProvider.type);
      
      if (activeProvider && activeProvider.id !== id) {
        setConflictModal({ open: true, current: activeProvider, next: selectedProvider });
        return;
      }
    }
    setConfirmDialog({ 
      open: true, 
      type: 'status', 
      data: { id, newStatus } 
    });
  };

  const handleResolveConflict = () => {
    if (conflictModal.current && conflictModal.next) {
      setProviders((prev) => prev.map(p => {
        if (p.id === conflictModal.current.id) return { ...p, isActive: false };
        if (p.id === conflictModal.next.id) return { ...p, isActive: true };
        return p;
      }));
    }
    setTimeout(() => {
      setConflictModal({ open: false, current: null, next: null });
    }, 0);
  };

  const handleAdd = (type) => {
    setEditData({ type });
    setIsAddProviderOpen(true);
  };

  const handleEdit = (provider) => {
    setEditData(provider);
    setIsAddProviderOpen(true);
  };

  const handleDelete = (provider) => {
    setConfirmDialog({ 
      open: true, 
      type: 'delete', 
      data: provider 
    });
  };

  const handleConfirmAction = async () => {
    setIsLoading(true);
    try {
      if (confirmDialog.type === 'delete') {
        setProviders(providers.filter(p => p.id !== confirmDialog.data.id));
      } else if (confirmDialog.type === 'status') {
        const { id, newStatus } = confirmDialog.data;
        setProviders(providers.map(p => 
          p.id === id ? { ...p, isActive: newStatus } : p
        ));
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
      setConfirmDialog({ open: false, type: null, data: null });
    }
  };

  const handleProviderSubmit = (providerData) => {
    if (editData?.id) {
      // Editing existing provider
      setProviders(providers.map(p => p.id === editData.id ? { ...providerData, type: editData.type } : p));
    } else {
      // Adding new provider
      setProviders([...providers, { ...providerData, type: editData.type }]);
    }
    setIsAddProviderOpen(false);
    setEditData(null);
  };

  const tabList = [
    {
      title: "Invoice Scheduler",
      component: <InvoiceSchedulerTab />
    },
    {
      title: "Templates",
      component: <TemplatesTab />
    },
    //    {
    //   title: "Download Excel",
    //   component: <DownloadExcel />
    // }
  ];

  return (
    <div className="flex flex-col">
      {/* Page Header */}
      <div className="gap-4 mb-6 flex items-center">
        <button
          className="p-2 border rounded-md"
          onClick={() => {
            navigate("/configurations");
          }}
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        <h1 className="text-2xl font-semibold text-blue-900">Invoice</h1>
      </div>

      {/* Main Tabs */}
      <CustomTab tabList={tabList} />

      {/* Provider Form Dialog */}
      <ProviderForm 
        open={isAddProviderOpen}
        onClose={() => {
          setIsAddProviderOpen(false);
          setEditData(null);
        }}
        editData={editData}
        onSubmit={handleProviderSubmit}
        type={editData?.type}
      />

      {/* Confirmation Dialog */}
      <CustomDialog
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ open: false, type: null, data: null })}
        title="Are You Sure?"
        titleClassName="text-center"
      >
        <div className="w-[400px] text-center">
          <p className="text-gray-600 text-left border-b pb-4">
            {confirmDialog.type === 'delete' 
              ? "Are you sure you want to delete this provider?"
              : "Are you sure you want to change the status of this provider?"}
          </p>
          <div className="flex justify-between gap-3 mt-4">
            <button
              className="py-2 px-4 bg-gray-200 font-semibold text-base w-[170px] rounded-md"
              onClick={() => setConfirmDialog({ open: false, type: null, data: null })}
            >
              Cancel
            </button>

            <button
              className="py-2 px-4 bg-blue-500 w-[170px] font-semibold text-base text-white rounded-md disabled:opacity-70"
              onClick={handleConfirmAction}
              disabled={isLoading}
            >
              {isLoading ? "Processing..." : "Confirm"}
            </button>
          </div>
        </div>
      </CustomDialog>

      {/* Provider Conflict Modal */}
      <CustomDialog
        open={conflictModal.open}
        noTitleWrapper={true}
        setOpen={(open) => setConflictModal({ ...conflictModal, open })}
        className="!p-0"
        
       
      >
        <div className="flex flex-col items-center text-center gap-2 p-7">
        <div className="flex  items-center gap-2 text-xl text-red-600 w-full !justify-center font-[600]">
            <AlertTriangle size={24} />
            <span>Provider Conflict</span>
        </div>
          <div className="font-semibold text-lg text-[#213650] text-center mt-5">Only one provider can be active at a time.</div>
          <div className="text-[#425F80] font-[400]  text-center">
            To activate <span className="font-semibold">{conflictModal.next?.providerName}</span>, please deactivate the <br /> currently active provider (<span className="font-semibold">{conflictModal.current?.providerName}</span>)first
          </div>
          <button
            className="flex items-center gap-1 mt-2 text-[#213650] font-semibold hover:underline"
            onClick={handleResolveConflict}
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 8.25V6.75A2.25 2.25 0 0 0 14.25 4.5h-4.5A2.25 2.25 0 0 0 7.5 6.75v10.5A2.25 2.25 0 0 0 9.75 19.5h4.5a2.25 2.25 0 0 0 2.25-2.25v-1.5" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 12h6m0 0-3-3m3 3-3 3" />
            </svg>
            Deactivate {conflictModal.current?.providerName} & Activate {conflictModal.next?.providerName}
          </button>
        </div>
        <div className="border-t " ></div>
        <div className="flex justify-center  gap-2 p-7">
          <button
            className="py-2 px-4 bg-gray-200 font-semibold text-base w-[170px] rounded-md"
            onClick={() => setConflictModal({ open: false, current: null, next: null })}
          >
            Cancel
          </button>
          <button
            className="py-2 px-4 bg-blue-500 w-[170px] font-semibold text-base text-white rounded-md"
            onClick={handleResolveConflict}
          >
            Activate
          </button>
        </div>
      </CustomDialog>
    </div>
  );
};

export default Invoice;